module.exports = __webpack_public_path__ + "img/hr-tree-04-d-trunk.c9206188.png";